import request from "@/router/axios.js";

//查询获客码企微问卷信息
export const getQuestionnaireInfo = (params) => {
  return request({
    url: "/api/ygj-pdsop/v1.0/customer-acquisition/get-questionnaire-info",
    method: "GET",
    params,
  });
};

//企微新客提交问卷
export const submitQuestionnaire = (data) => {
  return request({
    url: "/api/ygj-pdsop/v1.0/customer-acquisition-customer/submit-questionnaire",
    method: "POST",
    data,
  });
};
